import {CarrierLevel} from 'modules/decisionsNext/api/types';

export const carrierLevels = [
  CarrierLevel.UltimateParentCarrier,
  CarrierLevel.ParentCarrier,
  CarrierLevel.IssuingPaper,
];

export const carrierLevelLabelMap = {
  [CarrierLevel.UltimateParentCarrier]: 'Ultimate parent',
  [CarrierLevel.ParentCarrier]: 'Parent',
  [CarrierLevel.IssuingPaper]: 'Issuing paper',
};
